import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=0dd9a104&"
import script from "./privacy-policy.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsThePageTitleSection: require('/usr/src/nuxt-app/components/elements/ThePageTitleSection.vue').default})
